import { CmsPageContentIdentifier, TargetGroup, FilterCriteriaType } from '@/types/av-check';

export const initialState = {
  cmsContent: {
    [CmsPageContentIdentifier.Title]: '',
    [CmsPageContentIdentifier.Intro]: '',
    [CmsPageContentIdentifier.Instructions]: '',
    [CmsPageContentIdentifier.Faq]: '',
    [CmsPageContentIdentifier.FormFieldRequiredHint]: '',
    [CmsPageContentIdentifier.FormFieldPlaceholderZipCode]: '',
    [CmsPageContentIdentifier.FormFieldPlaceholderCity]: '',
    [CmsPageContentIdentifier.FormFieldPlaceholderStreet]: '',
    [CmsPageContentIdentifier.FormFieldPlaceholderHouseNumber]: '',
    [CmsPageContentIdentifier.FormFieldErrorMessageZipCodeRequired]: '',
    [CmsPageContentIdentifier.FormFieldErrorMessageZipCodeInvalid]: '',
    [CmsPageContentIdentifier.FormFieldErrorMessageCityRequired]: '',
    [CmsPageContentIdentifier.FormFieldErrorMessageStreetRequired]: '',
    [CmsPageContentIdentifier.FormFieldErrorMessageHouseNumberRequired]: '',
    [CmsPageContentIdentifier.FormFieldErrorMessageHouseNumberInvalid]: '',
    [CmsPageContentIdentifier.CheckButton]: '',
    [CmsPageContentIdentifier.ErrorMessageServerError]: '',
    [CmsPageContentIdentifier.ErrorMessageNoMatchingAddress]: '',
    [CmsPageContentIdentifier.ErrorMessageNoTariffOffers]: '',
    [CmsPageContentIdentifier.SuccessMessageAvailableDslOnly]: '',
    [CmsPageContentIdentifier.SuccessMessageAvailableFmsOnly]: '',
    [CmsPageContentIdentifier.SuccessMessageAvailableAll]: '',
    [CmsPageContentIdentifier.InfoMessageCorrectedAddress]: '',
    [CmsPageContentIdentifier.CheckOtherAddressLink]: '',
    [CmsPageContentIdentifier.TargetGroupNamePrivatkunden]: '',
    [CmsPageContentIdentifier.TargetGroupNamePrivatkundenInfo]: '',
    [CmsPageContentIdentifier.TargetGroupNameStudenten]: '',
    [CmsPageContentIdentifier.TargetGroupNameStudentenInfo]: '',
    [CmsPageContentIdentifier.TargetGroupNameSebstaendige]: '',
    [CmsPageContentIdentifier.TargetGroupNameSebstaendigeInfo]: '',
    [CmsPageContentIdentifier.TargetGroupNameBestandskunden]: '',
    [CmsPageContentIdentifier.TargetGroupNameBestandskundenInfo]: '',
    [CmsPageContentIdentifier.TargetGroupNameSonderbuchungen]: '',
    [CmsPageContentIdentifier.TargetGroupSwitcherLabel]: '',
    [CmsPageContentIdentifier.ContractDuration1Month]: '',
    [CmsPageContentIdentifier.ContractDuration24Month]: '',
    [CmsPageContentIdentifier.ContractDurationSwitcherLabel]: '',
    [CmsPageContentIdentifier.TariffButton]: '',
    [CmsPageContentIdentifier.NoTariffForSelection]: '',
    [CmsPageContentIdentifier.TariffCatalogDescription]: '',
    [CmsPageContentIdentifier.PriceHint]: '',
    [CmsPageContentIdentifier.ContinueWithSelectedTariffButton]: '',
    [CmsPageContentIdentifier.ContinueWithOtherTariffButton]: '',
    [CmsPageContentIdentifier.UpSellHint]: '',
    [CmsPageContentIdentifier.AlternativeHint]: '',
    [CmsPageContentIdentifier.MessageSelectedAvailable]: '',
    [CmsPageContentIdentifier.MessageSelectedNotAvailable]: '',
    [CmsPageContentIdentifier.TariffRecommendation]: '',
    [CmsPageContentIdentifier.TariffProductTypeHintDSL]: '',
    [CmsPageContentIdentifier.TariffProductTypeHintFMS]: '',
    [CmsPageContentIdentifier.SuccessMessageTitle]: '',
    [CmsPageContentIdentifier.SuccessMessageMaxBandwidth]: '',
    [CmsPageContentIdentifier.TechnologyPricingMonthlyList]:'',
    [CmsPageContentIdentifier.TechnologyPricingInfrastructureCharge]:'',
    [CmsPageContentIdentifier.TechnologyPricingDevelopmentCharge]:'',
    [CmsPageContentIdentifier.TechnologyPricingOneTimeMonthlyDiscount]:'',
    [CmsPageContentIdentifier.TechnologyPricingConnectionDiscount]:'',
    [CmsPageContentIdentifier.TechnologyPricingDevelopmentDisount]:'',
    [CmsPageContentIdentifier.TargetGroupNamePrivatkundenInfoIcon]: '',
    [CmsPageContentIdentifier.TargetGroupNameStudentenInfoIcon]: '',
    [CmsPageContentIdentifier.TargetGroupNameSebstaendigeInfoIcon]: '',
    [CmsPageContentIdentifier.TargetGroupNameBestandskundenInfoIcon]: '',
    [CmsPageContentIdentifier.FtthExpectedExpansionText]: '',
    [CmsPageContentIdentifier.ExpectedExpansionDateText]: '',
    [CmsPageContentIdentifier.FtthFreeConversionServiceText]: '',
    [CmsPageContentIdentifier.ComboBenefitInfo]: '',
    [CmsPageContentIdentifier.DevelopmentPrinceInfoText]: '',
    [CmsPageContentIdentifier.FtthAvailabilityModalFooterInfo]: '',
    [CmsPageContentIdentifier.HomeAvailabilityModalContactInfo]: '',
    [CmsPageContentIdentifier.HomeAvailabilityModalContactDiscription]: '',
    [CmsPageContentIdentifier.FtthDevelopmentInfoText]: '',
    [CmsPageContentIdentifier.FtthAlertBoxText]: '',
  },
  address: {
    zipCode: '',
    city: '',
    street: '',
    houseNumber: '',
    corrected: false,
  },
  result: undefined,
  resultError: false,
  currentTargetGroup: TargetGroup.PRIVATKUNDEN,
  currentContractDuration: 24,
  cityList: undefined,
  streetList: undefined,
  filterValues: {
    [FilterCriteriaType.TARGET_GROUP]: TargetGroup.PRIVATKUNDEN,
    [FilterCriteriaType.CONTRACT_DURATION]: 24,
    [FilterCriteriaType.SPECIAL_RESERVATION]: false,
  },
  householdConfig: {
    personInHousehold: 0,
    usageTypes: [],
  },
  trackingInfo: {
    isFirstSliderView: true,
    sliderTariffPositions: {},
  }
};

export default initialState;
